import {
  FormControl,
  FormControlProps,
  FormErrorMessage,
  FormLabel,
  FormLabelProps,
  Input,
  InputProps,
} from "@chakra-ui/react";
import { Fragment } from "react";

export function TsdsInput(
  props: InputProps & { label?: string } & {
    formControl?: FormControlProps;
  } & { formLabel?: FormLabelProps } & {error?:string}
) {
  function getInput({ type }: any) {
    return (
      <Input
        // w={300}
        type={type || "text"}
        // borderColor={"grey3"}
        // borderWidth={2}
        // bgColor={"white"}
        _active={{ border: "2px solid", borderColor: "green4" }}
        _focus={{ border: "2px solid", borderColor: "green4" }}
        _hover={{ border: "2px solid", borderColor: "green4" }}
        {...props}
      />
    );
  }

  return (
    <Fragment>
      {props.label ? (
        <FormControl {...props.formControl}>
          <FormLabel
            {...props.formLabel}
            my={0}
            mx={0}
            color={props.isDisabled ? "grey" : "black"}
          >
            {props.label} <span style={{'color':'red'}}>{(props.isRequired)?' *':''}</span>
          </FormLabel>
          {getInput({ type: props.type })}
          {(props.error)?<FormErrorMessage>{props.error}</FormErrorMessage>:<></>}
        </FormControl>
      ) : (
        <Fragment>{getInput({ type: props.type })}</Fragment>
      )}
    </Fragment>
  );
}
